import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase } from '@mui/material';

// project imports
import SearchSection from './SearchSection';
import ProfileSection from './ProfileSection';
import logoImg from 'assets/images/logo.png';
// assets
import { IconMenu2 } from '@tabler/icons-react';
import AboutDialog from 'containers/About';
import ApiHelper from 'utils/apiHelper';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle, searchDevices }) => {
    const theme = useTheme();
    const [showAboutDialog, setShowAboutDialog] = useState(false);
    const [serverVersion, setServerVersion] = useState('');

    useEffect(() => {
        getServerVersion();
    }, []);

    const getServerVersion = () => {
        ApiHelper.get('/api/server/version/')
            .then((res) => {
                setServerVersion(res.data);
            })
            .catch(() => {
                toast.error('Failed to get the server version data');
            });
    };

    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    height: 70,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Box
                    component="span"
                    sx={{ display: { xs: 'none', md: 'flex' }, flexGrow: 1, cursor: 'pointer', justifyItems: 'center' }}
                    onClick={() => setShowAboutDialog(true)}
                >
                    <img src={logoImg} width="150" alt="WakeSMART" style={{ margin: 'auto' }} />
                </Box>
                <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }} aria-label="menu">
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            transition: 'all .2s ease-in-out',
                            background: theme.palette.secondary.light,
                            color: theme.palette.secondary.main,
                            '&:hover': {
                                background: theme.palette.secondary.main,
                                color: theme.palette.secondary.light
                            }
                        }}
                        onClick={handleLeftDrawerToggle}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </Avatar>
                </ButtonBase>
                {showAboutDialog && <AboutDialog onClose={() => setShowAboutDialog(false)} serverVersion={serverVersion} />}
            </Box>

            {/* header search */}
            {searchDevices && <SearchSection />}

            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />

            {/* notification & profile */}
            {/* <NotificationSection /> */}
            <ProfileSection />
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func,
    searchDevices: PropTypes.bool
};

export default Header;
